.viewer {
  position: relative;
  margin-top: 0.75rem;
  overflow: hidden;
  border: 1px solid var(--color-code-border);
  border-radius: var(--radius-lg);
  background: var(--color-code-background);
  color-scheme: dark;
}

.code {
  max-height: 60vh;
  margin: 0;
  border: 0;
  border-radius: 0;
}
